// -----------------------------------------------------------
// FloraIQ - LadmStatusBadge
// Badge padronizado para status da metodologia LADM
// -----------------------------------------------------------

import { type FC } from "react";

export type LadmBadgeVariant = "implantado" | "parcial" | "pendente" | "inconsistente" | "vigente" | "executada" | "em_andamento" | "em_analise" | "pendente_aprovacao" | "validado" | "completo" | "incompleto" | "concluido" | "processando" | "disponivel" | "critica" | "alta" | "media" | "baixa";

interface LadmStatusBadgeProps {
  variant: LadmBadgeVariant;
  className?: string;
}

const variantConfig: Record<LadmBadgeVariant, { bg: string; text: string; dot: string; label: string }> = {
  implantado: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Implantado" },
  parcial: { bg: "bg-yellow-100", text: "text-yellow-800", dot: "bg-yellow-500", label: "Parcial" },
  pendente: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500", label: "Pendente" },
  inconsistente: { bg: "bg-red-100", text: "text-red-800", dot: "bg-red-500", label: "Inconsistente" },
  vigente: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Vigente" },
  executada: { bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-500", label: "Executada" },
  em_andamento: { bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-500", label: "Em andamento" },
  em_analise: { bg: "bg-yellow-100", text: "text-yellow-800", dot: "bg-yellow-500", label: "Em análise" },
  pendente_aprovacao: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500", label: "Pendente aprovação" },
  validado: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Validado" },
  completo: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Completo" },
  incompleto: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500", label: "Incompleto" },
  concluido: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Concluído" },
  processando: { bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-500", label: "Processando" },
  disponivel: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Disponível" },
  critica: { bg: "bg-red-100", text: "text-red-800", dot: "bg-red-500", label: "Crítica" },
  alta: { bg: "bg-red-100", text: "text-red-800", dot: "bg-red-500", label: "Alta" },
  media: { bg: "bg-yellow-100", text: "text-yellow-800", dot: "bg-yellow-500", label: "Média" },
  baixa: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", label: "Baixa" },
};

const LadmStatusBadge: FC<LadmStatusBadgeProps> = ({ variant, className = "" }) => {
  const config = variantConfig[variant];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${config.bg} ${config.text} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
      {config.label}
    </span>
  );
};

export default LadmStatusBadge;